// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14JvK","tabsBox":"styles_tabsBox__1q0dW","createButton":"styles_createButton__Gs1Iy"};